import { map } from 'lodash/fp';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { SimpleList } from '@optimus-web/core';
import { OrderItem, ApplicationState, WithServiceId, WithTimeUnit } from '@mews-commander/types';
import { isCurrentEnterpriseInMultiTaxEnvironment } from '@mews-commander/legacy-entities/src/selectors/session/enterprise';
import { getTimeUnitByServiceId } from '@mews-commander/legacy-entities/src/ducks/services';
import DefaultProductOrderItemsListItem from './DefaultProductOrderItemsListItem';

interface OwnProps extends WithServiceId {
    nights: OrderItem[];
}
interface StateProps extends WithTimeUnit {
    isMultiTaxEnvironment: boolean;
}
type Props = OwnProps & StateProps;

const DefaultProductOrderItemsList = ({ nights, isMultiTaxEnvironment, timeUnit }: Props) => (
    <SimpleList spacing="0" listStyle="none" plain>
        {map(
            (night) => (
                <DefaultProductOrderItemsListItem
                    key={`night-${night.startUtc}`}
                    night={night}
                    timeUnit={timeUnit}
                    isMultiTaxEnvironment={isMultiTaxEnvironment}
                />
            ),
            nights
        )}
    </SimpleList>
);

export default connect(
    createStructuredSelector<ApplicationState, OwnProps, StateProps>({
        timeUnit: getTimeUnitByServiceId,
        isMultiTaxEnvironment: isCurrentEnterpriseInMultiTaxEnvironment,
    })
)(DefaultProductOrderItemsList);
